export default {"src":"/_next/static/media/footerTopDesktopPurple.9dc6f845.svg","height":202,"width":1095,"blurWidth":0,"blurHeight":0};